module.exports = __webpack_public_path__ + "static/media/astrid_levelup_wordcraft.1101c9a9.png";